var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card border-0 rounded-75 shadow-sm w-100 h-100 overflow-hidden",class:{ 'p-3': !_vm.noPadding }},[_c('div',{staticClass:"card-body p-0"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }